import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { IupicsCookieService } from '@iupics-manager/managers/security-manager/cookies/iupics-cookie.service';
import { SecurityManagerService } from '@iupics-manager/managers/security-manager/security-manager.service';
import { SessionService } from '@iupics-manager/managers/session/session.service';
import { Global } from '@iupics-manager/models/global-var';
import { Observable, throwError } from 'rxjs';
import { catchError, finalize, map } from 'rxjs/operators';

@Injectable()
export class HttpInterceptorService implements HttpInterceptor {
  #connectorService = inject(SecurityManagerService);
  #cookieService = inject(IupicsCookieService);
  #session = inject(SessionService);

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    Global.requestStarted();

    const cachedDefaultLanguageIsoCode = this.#cookieService.getCachedDefaultLanguageIsoCode();
    if (cachedDefaultLanguageIsoCode) {
      request = request.clone({
        setHeaders: {
          'X-Lang': `${cachedDefaultLanguageIsoCode}`,
        },
      });
    } else if (this.#connectorService.getIupicsUserAccount()) {
      if (this.#connectorService.getIupicsUserAccount().default_language) {
        request = request.clone({
          setHeaders: {
            'X-Lang': `${this.#connectorService.getIupicsUserAccount().default_language.iso_code}`,
          },
        });
      }
    }
    Global.lastActivity = new Date();
    return next.handle(request).pipe(
      map((event) => {
        return event;
      }),
      catchError((err) => {
        // one logout for several parallel 401 (each one logged out on its own)
        if (err instanceof HttpErrorResponse && err.status === 401) this.#session.logout();
        return throwError(() => err);
      }),
      finalize(() => Global.requestEnded())
    );
  }
}
